export enum FailureSeverity {
  Error = 1,
  Warning = 2,
}
